var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.longitude && _vm.longitude)?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getMapUrl())}}),_c('div',{staticClass:"font-12 text-white bg-blue500 location-footer d-flex align-items-center py-2"},[_c('IconV2',{staticClass:"ms-2 me-1",attrs:{"name":"v2-location","color":"white"}}),_c('span',[_vm._v("Vị trí của tôi")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }